/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";

// "controllers"
import { ModelController } from "controllers";

const ModelSearch = ({ onClick }) => {
    const [items, setItems] = useState([]);

    const handleClick = (model) => {
        onClick(model);
    }
    const handleChange = async (event) => {
        const { value } = event.target;

        if (!value) {
            setItems([]);
            return;
        }

        let newList = [];

        newList = await ModelController.getModelsByQuery({ field: "SKU", search: value, itemsPerPage: 5 });

        setItems(newList);
    }

    return (
        <>
            <div className="field">
                <div className="control">
                    <input className="input"
                        type="text" placeholder="Search model by SKU"
                        onChange={handleChange} />
                </div>
            </div>

            <nav className="panel is-over has-background-white">
                {items.map((model) => (
                    <div key={model.id} className="panel-block is-clickable p-4 is-shadowless" onClick={() => handleClick(model)}>
                        <div className="columns is-mobile">
                            <div className="column">
                                <figure className="image is-64x64">
                                    <img src={model.imageURLs[0]} alt={model.name} />
                                </figure>
                            </div>
                            <div className="column is-full">
                                <p className="tag is-full is-light is-size-4">{model.supplier}</p>
                                <div className="is-size-5 block">
                                    <small>SKU:</small> {model.SKU}
                                    <br />
                                    <small>Brand:</small> {model.brand}
                                    <br />
                                    <small>Name:</small> {model.name}
                                </div>
                            </div>
                        </div>

                    </div>
                ))}
            </nav>
        </>
    );
}

export default ModelSearch;
